import { aiCopilotIsOn } from '@repo/editor/src/hooks/copilot/useIsAiCopilotEnabled';
// The function returns the labels for the pricing page comparison table.
// The values come from the editor module.
export const getComparisonKeys = () => {
  const isCopilotFeatureOn = aiCopilotIsOn();

  return {
    features: [
      { label: 'Downloads', tooltip: 'Download limit' },
      {
        label: 'Brand Kits',
        tooltip: 'The number of Brand Kits you can create',
      },
      {
        label: 'Saving projects',
        tooltip: 'The number of projects you can save',
      },
      {
        label: 'Custom graphics upload',
        tooltip: 'The storage limit for uploaded graphics',
      },
      {
        label: 'Challenge submissions',
        tooltip: 'The number of designs you can submit to a challenge',
      },
      {
        label: 'Export vector files',
        tooltip: 'Exporting scalable vector files in SVG & PDF format',
      },
      {
        label: 'Export hig-res images',
        tooltip: 'Exporting high resolution images up to 6000px',
      },
      {
        label: 'Custom fonts upload',
        tooltip: 'Uploading font files to Kittl (OTF, TTF)',
      },
      {
        label: 'Custom Artboard sizes',
        tooltip: 'Set custom artboard sizes to any ratio',
      },
      {
        label: 'Transparent Exports',
        tooltip: 'Export images without a background',
      },
      {
        label: 'Optimize quality',
        tooltip: 'Optimize the quality of your image exports',
      },
    ],
    aiDesignTools: [
      {
        label: 'Kittl AI Credits',
        tooltip: 'The amount of credits to use Kittl AI',
      },
      {
        label: 'Private AI Image Generation',
        tooltip: 'AI Generated Images for private use',
      },
      {
        label: 'AI Image Gen: Turbo Model',
        subtitle: '(1 credit per image)',
        tooltip: 'Use Kittl AI ImageGen Turbo Model',
      },
      {
        label: 'AI Image Gen: Advanced Model',
        subtitle: '(2 credits per image)',
        tooltip: 'Use Kittl AI ImageGen Advanced Model',
      },
      {
        label: 'AI Image Gen Saved Styles',
        tooltip: 'The storage limit for Saved Styles',
      },
      ...(isCopilotFeatureOn
        ? [
            {
              label: 'Kittl Copilot',
              tooltip: 'Design smarter and faster with AI',
            },
          ]
        : []),
      {
        label: 'AI Design Gen',
        tooltip: 'Generate editable designs with AI',
      },
      {
        label: 'AI Text Gen',
        subtitle: '(1 credit for Free users)',
        tooltip: 'Generate editable text with AI',
      },
      {
        label: 'AI Erase & Fill',
        tooltip: 'Automatically fill backgrounds of erased areas',
      },
      {
        label: 'AI Image Restyle',
        subtitle: '(1 credit per generation)',
        tooltip: 'Change an image style and keep the same content',
      },
      ...(isCopilotFeatureOn
        ? [
            {
              label: 'AI Image Switch',
              subtitle: '(1 credit per generation)',
              tooltip: 'Change an image content and keep the same style',
            },
          ]
        : []),
      {
        label: 'AI Background Remover',
        subtitle: '(1 credit for Free users)',
        tooltip: 'Automatically remove backgrounds in images',
      },
      {
        label: 'AI Image Upscaler',
        subtitle: '(1 credit for Free users)',
        tooltip: 'Automatically enhance image quality',
      },
      {
        label: 'AI Quote Gen',
        subtitle: '(1 credit per quote)',
        tooltip: 'Generate quotes using AI',
      },
      {
        label: 'AI Product Backgrounds',
        subtitle: '(1 credit per generation)',
        tooltip: 'Generate background scenes for your product images',
      },
    ],
    licensing: [
      {
        label: 'Personal Use',
        tooltip: 'Use designs for personal, non commercial projects',
      },
      {
        label: 'Commercial Use',
        tooltip: 'Use designs for commercial projects or products to sell',
      },
    ],
    content: [
      {
        label: 'Photo Library',
        tooltip: 'Use the full library of professional photos',
      },
      {
        label: 'Illustration Library',
        tooltip: 'Use the full library of illustrations, icons and more',
      },
      {
        label: 'Texture Library',
        tooltip: 'Use the full library of textures ',
      },
      {
        label: 'Font Library',
        tooltip: 'Use the full library of fonts',
      },
      {
        label: 'Premium Mockups',
        tooltip: 'Use all premium mockups',
      },
      {
        label: 'Full Color Palette Library',
        tooltip: 'Use all premade color palettes',
      },
      {
        label: 'Premium Templates',
        tooltip: 'Use premium templates provided by Kittl Creators',
      },
    ],
    businessAddons: [
      {
        label: 'Team workspaces',
        tooltip: 'Use one workspace with multiple people',
      },
      {
        label: 'Multiple users on one file',
        tooltip: 'Work with multiple people on the same project',
      },
      {
        label: 'History & Time machine',
        tooltip: 'Move back to previous versions of your project',
      },
      {
        label: 'Custom brand management',
        tooltip: 'Brand boards and custom brand features',
      },
      {
        label: 'Custom design requests',
        tooltip: 'Request custom designs from the Kittl design team',
      },
      {
        label: '24/7 Advanced support',
        tooltip: 'Get fast support at any time',
      },
    ],
  };
};
